import { render, staticRenderFns } from "./RowSpecificationModal.vue?vue&type=template&id=2620aace&scoped=true&"
import script from "./RowSpecificationModal.vue?vue&type=script&lang=js&"
export * from "./RowSpecificationModal.vue?vue&type=script&lang=js&"
import style0 from "./RowSpecificationModal.vue?vue&type=style&index=0&id=2620aace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620aace",
  null
  
)

export default component.exports